import axios from "axios";
import { AuthService } from "../services/AuthService ";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
const axiosInstance = axios.create({
    // baseURL: process.env.REACT_APP_API_URL || "http://localhost:4000",
    withCredentials: true, // This will send cookies with every request
});

axiosInstance.interceptors.request.use(
    async (config: any) => {
        // Exclude the refresh token endpoint from triggering token logic
        if (config.url?.includes("/apiauth") || config.url?.includes("/machineauth")) {
            return config;
        }

        const authService = new AuthService(`${API_BASE_URL}/api/matiga/pesowifi/apiauth`);
        let token = localStorage.getItem("accessToken") || null
        if (!token) {
            try {
                // Try to refresh the access token using the refresh token cookie
                token = await authService.login({ username: "", password: "" }) || null;
                localStorage.setItem("accessToken", token || "");
                console.log("Obtained new access token via login");
            } catch (error) {
                // If refresh fails, redirect or handle error
                // authService.clearTokens();
                window.location.href = "/notauthorized";// navigateState('/notauthorized');
                return config;
            }
        }
        if (token && config.headers) {
            config.headers["peso-wifi-auth"] = token;
        }
        return config;
    }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Prevent infinite loop: only retry once
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const authService = new AuthService(`${API_BASE_URL}/api/matiga/pesowifi/apiauth`);
      console.log("Access token expired, attempting to refresh...");

      try {
        const newToken = await authService.refreshAccessToken();
        localStorage.setItem("accessToken", newToken || "");
        originalRequest.headers["peso-wifi-auth"] = newToken;

        return axiosInstance(originalRequest); // retry once
      } catch (refreshError) {
        window.location.href = "/notauthorized";
      }
    }

    if (error.message === "Network Error") {
      window.location.href = "/noserviceavailable";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;